import React, { ReactNode } from "react";
import { useExperimentIsVariant } from "@capone/experiments";
import {
  BrandedHotelLoyaltyPill,
  isBrandedHotelLoyaltyProgramCode,
} from "@capone-corporate/portal";
import {
  AVAILABLE,
  CORP_HOTELS_BRANDED_LOYALTY_EXPERIMENT,
} from "../../../../context/experiments";

export const useBrandedLoyaltyChip = (
  loyaltyProgramCode: string | null | undefined,
): ReactNode => {
  const isBrandedLoyaltyExperiment = useExperimentIsVariant(
    CORP_HOTELS_BRANDED_LOYALTY_EXPERIMENT,
    AVAILABLE,
  );

  if (
    !isBrandedLoyaltyExperiment ||
    !isBrandedHotelLoyaltyProgramCode(loyaltyProgramCode)
  ) {
    return undefined;
  }

  return <BrandedHotelLoyaltyPill loyaltyProgramCode={loyaltyProgramCode} />;
};
